import React from 'react';
import { EventComponent } from 'components';
import { useIsMobile } from 'hooks';

function Detail() {
  const isMobile = useIsMobile();

  if (isMobile) return <EventComponent.MobileDetail />;

  return (
    <div>
      <EventComponent.Detail />
    </div>
  );
}

export default Detail;
